<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>如收款资料页面没有附言，转账时的附言栏位请留空白</li>
      <li>如留下备注或附言会造成交易失败，若交易失败，资金会需要至少七个工作天才可以退款</li>
      <li style="color: #ff5455">每次入金如以过去旧有收款账号操作入金，其所存入金额将无法追回，敬请留意</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'MdAlert'
}
</script>
